import { createContext, useContext } from 'react';

export const TrackerContext = createContext(null);
export const useTracker = () => useContext(TrackerContext);
